import {
  GENDER_OPTIONS,
  ETHNICITY_OPTIONS,
  HEALTH_CONDITION_OPTIONS,
  ALZHEIMERS_STATUS_OPTIONS,
  US_STATES
} from "../../constants/patientOptions";

export const PATIENT_FILTER_FIELDS = {
  patientAccountNumber: {
    group: "personal",
    label: "MRN",
    control: "text",
    operator: "startsWith",
    placeholder: "Starts with"
  },
  firstName: {
    group: "personal",
    label: "First Name",
    control: "text",
    operator: "contains",
    placeholder: "Contains"
  },
  lastName: {
    group: "personal",
    label: "Last Name",
    control: "text",
    operator: "contains",
    placeholder: "Contains"
  },
  gender: {
    group: "personal",
    label: "Gender",
    control: "select",
    options: GENDER_OPTIONS
  },
  ethnicity: {
    group: "personal",
    label: "Ethnicity",
    control: "multiSelect",
    options: ETHNICITY_OPTIONS
  },
  city: {
    group: "personal",
    label: "City",
    control: "text",
    operator: "contains",
    placeholder: "Contains"
  },
  state: {
    group: "personal",
    label: "State",
    control: "multiSelect",
    options: US_STATES
  },
  zipCode: {
    group: "personal",
    label: "ZIP Code",
    control: "text",
    operator: "startsWith",
    placeholder: "Starts with"
  },
  alzheimersStatus: {
    group: "medical",
    label: "Alzheimer's Status",
    control: "select",
    options: ALZHEIMERS_STATUS_OPTIONS,
    hideNoneOption: true
  },
  medicalHistory: {
    group: "medical",
    label: "Medical History",
    control: "multiSelect",
    options: HEALTH_CONDITION_OPTIONS
  },
  medicalHistoryOther: {
    group: "medical",
    label: "Other",
    control: "text",
    operator: "contains",
    placeholder: "Contains"
  },
  familyHistory: {
    group: "medical",
    label: "Family History",
    control: "multiSelect",
    options: HEALTH_CONDITION_OPTIONS
  },
  familyHistoryOther: {
    group: "medical",
    label: "Other",
    control: "text",
    operator: "contains",
    placeholder: "Contains"
  },
  smoking: {
    group: "lifestyle",
    label: "Smoking",
    control: "select",
    optionsKey: "YesNo"
  },
  drinking: {
    group: "lifestyle",
    label: "Drinking",
    control: "select",
    optionsKey: "YesNo"
  },
  exercise: {
    group: "lifestyle",
    label: "Exercise",
    control: "select",
    optionsKey: "YesNo"
  },
  irbStudies: {
    group: "research",
    label: "IRB Study",
    control: "multiSelect",
    optionsSource: "GET /api/admin/patients/studies"
  },
  redcapMatchStatuses: {
    group: "research",
    label: "REDCap Match",
    control: "select",
    options: [
      { label: "Matched", value: "MATCHED" },
      { label: "Unmatched", value: "UNMATCHED" },
      { label: "Conflict", value: "CONFLICT" }
    ]
  }
};
